const UserTypeEnum = {
  ADMIN: "ADMIN",
  STUDENT: "STUDENT",
  SCHOLARSHIP_STUDENT: "SCHOLARSHIP_STUDENT",
  EXTERNAL: "EXTERNAL",
};

export default UserTypeEnum;
